import {
  HttpInterceptorFn,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ApiResponseDto } from '@infrastructure/dto/api-response-dto';
import { TranslateService } from '@ngx-translate/core';


export const messageInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  const translate = inject(TranslateService);
 return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          const body = event.body as ApiResponseDto<any>;

          if (body && typeof body.Ok === 'boolean' && body.Message) {
            notificationService.show({
              content: translate.instant(body.Message),
              cssClass: body.Ok
                ? 'bg-green-500 text-white'
                : 'bg-red-500 text-white',

              position: body.Ok
                ? { horizontal: 'center', vertical: 'top' } // ✅ como estaba
                : { horizontal: 'center', vertical: 'top' }, // ❌ error: más visible al centro

              type: { style: body.Ok ? 'success' : 'error', icon: true },

              hideAfter: body.Ok ? 5000 : 0, // ❌ error no se cierra solo
              closable: !body.Ok,            // ❌ solo errores se cierran manualmente
            });
          }
        }
      },
      error: (error: HttpErrorResponse) => {
       //si es 401 quitar el token
       if (error.status === 401) {
          // localStorage.removeItem('token');
          localStorage.removeItem('token');
          //reenviar a login
          window.location.href = '/login';
          return;

       }
        notificationService.show({
          content:
            error.error?.Message || 'Error en la comunicación con el servidor',
          cssClass: 'bg-red-600 text-white',

          position: { horizontal: 'center', vertical: 'top' }, // ❌ siempre centrado
          type: { style: 'error', icon: true },

          hideAfter: 0,  // ❌ se mantiene hasta que el usuario cierre
          closable: true,
        });
      },
    })
  );
};
